import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from 'api/constants';
import { resolve } from 'api/resolve';

import { useOwnershipApi } from '../ownership-api';

export const useFetchOwnershipMapping = (projectId: string, enabled: boolean = true) => {
  const { getOwnershipMapping } = useOwnershipApi();

  return useQuery({
    queryKey: [QUERY_KEYS.OWNERSHIP_MAPPINGS, projectId],
    queryFn: () => resolve(getOwnershipMapping(projectId)),
    enabled: enabled && !!projectId,
    // A query with no data (including one that's errored) otherwise refetches every time a new
    // observer subscribes — e.g. every keystroke-driven re-render of a component that reads this
    // hook. `useProjectTeams` is opted into the same behaviour from `useOwnershipMapping`, since the
    // two are surfaced to the user as a single "could not load owners" state. A failed fetch clears
    // on a page refresh, which is what OwnershipSelector's error alert tells the user.
    retryOnMount: false
  });
};
